import React, { useContext, useEffect, useState } from "react";
import DashboardSideBar from "../component/DashboardSideBar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { userContext } from "../context/UserContext";
import { api_url } from "../helpers";

const MyOrder = () => {
  const navigate = useNavigate();
  const { setUser, setLoad, user, cart } = useContext(userContext);
  const [cartProducts, setCartProducts] = useState([]);
  const [OrderHistory, setOrderHistory] = useState([]);

  async function MyOrderData() {
    setLoad(true);
    const fields = JSON.stringify(["*"]);
    const filters = JSON.stringify([
      ["customer", "=", user?.customer_id],
      ["docstatus", "=", 1],
    ]);

    const responseData = await fetch(
      api_url +
        `resource/Sales Order?fields=${encodeURIComponent(
          fields
        )}&limit_page_length=20&limit_start=0&filters=${encodeURIComponent(
          filters
        )}`,
      {
        headers: {
          Authorization: `token ${user?.api_key}:${user?.api_secret}`,
        },
      }
    );

    if (responseData.ok == true) {
      const data = await responseData.json();

      console.log(data);

      if (data?.data?.length > 0) {
        setOrderHistory(data?.data);
      }
    }

    setTimeout(() => {
      setLoad(false);
    }, 300);
  }

  useEffect(() => {
    MyOrderData();
  }, []);

  return (
    <section>
      <div className="container UserDetails-custom">
        <div className="row">
          <DashboardSideBar
            currentPage="My Order"
            navigate={navigate}
            setUser={setUser}
          />

          <div className="col-lg-9 mt-24 mb-30">
            {OrderHistory?.length > 0 ? (
              <div className="dashboard-right-my-order-table">
                <div>
                  <h6 className="ps-18 pt-18 text-lg">ORDER HISTORY</h6>
                </div>
                <hr className="m-0 p-0" />
                <div className="overflow-x-auto scroll-sm scroll-sm-horizontal w-100">
                  <table className="w-100 myOrder-table">
                    <thead className="dashboard-right-my-order-table-thead">
                      <tr>
                        <th className="">ORDER ID</th>
                        <th className="">STATUS</th>
                        <th className="">DATE</th>
                        <th className="">TOTAL</th>
                        <th className="">ACTION</th>
                      </tr>
                    </thead>
                    <tbody className="dashboard-right-my-order-table-tbody">
                      {OrderHistory?.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td className="">{item?.name}</td>
                            <td
                              className={
                                item?.delivery_status == "Not Delivered"
                                  ? "td-text-color-InProgress"
                                  : "td-text-color-completed"
                              }
                            >
                              {item?.delivery_status}
                            </td>
                            <td className="">{item?.creation}</td>
                            <td className="">{`${item?.total} KD ( ${
                              item?.total_qty
                            } ${
                              item?.total_qty > 1 ? "Products" : "Product"
                            } )`}</td>
                            <td className="">
                              <Link
                                to={`/order-detail?id=${item?.name}`}
                                className="d-inline-flex align-items-center rounded-pill gap-8 text-success"
                              >
                                View Details
                                <span className="icon text-xl d-flex">
                                  <i className="ph ph-arrow-right" />
                                </span>
                              </Link>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="d-flex flex-column align-items-center col-lg-9 my-36 w-100">
                <div className="w-50 d-flex justify-content-center">
                  <img
                    src="assets/images/bg/norecordfound.png"
                    alt=""
                    className=""
                  />
                </div>
                <div className="mt-40">
                  <h3 className="d-flex justify-content-center">
                    No Record Found!
                  </h3>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MyOrder;
